<div class="main-container">
    <app-page-header backLabel="Back" (back)="onBackClick()"></app-page-header>

    <ng-container *ngIf="!isProfileForm">
        <div class="message-container">
            <mat-card class="MessagecardNew">
                <mat-card-content class="CardMessage">
                    <p [innerHTML]="userMessage"></p>
                </mat-card-content>
            </mat-card>
        </div>
    </ng-container>

    <div class="card-container">
        <mat-card *ngIf="isProfileForm" aria-labelledby="long-card-title" appearance="outlined" id="containerCard">
            <header>
                <mat-card-title>
                    <h4 topazTitle="1" class="merge-acc-text">Change your MCT Account Email</h4>
                </mat-card-title>
            </header>
            <mat-card-content>
                <p>Enter the email address you’d like to use for your MCT account</p>
                <form [formGroup]="emailForm">
                    <div class="grid-layout">

                        <mat-form-field>
                            <input type="text" placeholder="Email*" matInput formControlName="email" />
                        </mat-form-field>

                        <mat-form-field>
                            <input type="email" placeholder="New email id*" matInput formControlName="newEmail"
                                required />
                            <mat-error
                                *ngIf="emailForm.get('newEmail')?.hasError('required') && emailForm.get('newEmail')?.touched">
                                Email id is required
                            </mat-error>
                            <mat-error
                                *ngIf="emailForm.get('newEmail')?.hasError('invalidEmail') && emailForm.get('newEmail')?.touched">
                                Please enter a valid email address (e.g., user&#64;example.com)
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <input type="text" placeholder="Reason*" matInput formControlName="user_remarks" required />
                            <mat-error
                                *ngIf="emailForm.get('user_remarks')?.hasError('required') && emailForm.get('user_remarks')?.touched">
                                Reason is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </form>
            </mat-card-content>
            <mat-card-actions align="end" class="btn-actions" id="buttons">
                <button mat-button class="topaz-button-small" id="cancel" (click)="onBackClick()">
                    Cancel
                </button>
                <button [disabled]="isFormSubmitted" mat-flat-button class="topaz-button-small" id="submit" (click)="onSave()">
                    Submit
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>